import Vue from 'vue'
import Element from 'element-ui'
import '@styles/global.scss'
Vue.use(Element)
